import React from 'react';
import { motion } from 'framer-motion';
export function EmptyState({
  message
}: {
  message: string;
  sub?: string;
}) {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    duration: 0.8,
    ease: [0.23, 1, 0.32, 1]
  }} className="flex flex-col items-center justify-center py-24 px-6" data-id="element-962">
      <p className="text-[#8a8680]/50 text-[15px] tracking-wide text-center" data-id="element-963">{message}</p>
    </motion.div>;
}